import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
export function FeaturesSection() {
  const features = ['Instructores que realmente te guían — no te ignoran', 'Entrenamientos de musculación diseñados para tu cuerpo y tu nivel', 'Clases funcionales que mejoran cómo te mueves en la vida real', 'Orientación nutricional para que lo que comes trabaje A FAVOR de tus entrenamientos', 'Una comunidad que te impulsa, no te intimida', 'Atención personalizada desde el primer día'];
  return <section className="py-24 bg-gym-charcoal" data-id="element-52">
      <div className="max-w-5xl mx-auto px-4" data-id="element-53">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-55">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 uppercase tracking-wide text-white" data-id="element-56">
              Dónde sucede <span className="text-gym-green" data-id="element-57">todo esto</span>
            </h2>

            <div className="flex items-start gap-4 mb-6 bg-gym-charcoalLight p-6 rounded-xl border border-gym-charcoal" data-id="element-58">
              <MapPin size={32} className="text-gym-gold shrink-0 mt-1" data-id="element-59" />
              <div data-id="element-60">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-61">
                  En el corazón de San Miguel
                </h3>
                <p className="text-gray-400" data-id="element-62">
                  Esquina Av. Brígida Silva de Ochoa con Calle Angélica Palma
                  195, 2do piso, Lima.
                </p>
                <p className="text-gray-300 mt-4 italic" data-id="element-63">
                  "Hay un espacio donde la gente de tu distrito está
                  transformando su cuerpo de verdad."
                </p>
              </div>
            </div>

            <div className="mb-8 rounded-xl overflow-hidden border border-gym-charcoal shadow-lg" data-id="element-64">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3901.5!2d-77.09!3d-12.077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zQXYuIEJyw61naWRhIFNpbHZhIGRlIE9jaG9hIGNvbiBDYWxsZSBBbmfDqWxpY2EgUGFsbWEgMTk1LCBTYW4gTWlndWVsLCBMaW1h!5e0!3m2!1ses!2spe!4v1700000000000" width="100%" height="220" style={{
              border: 0,
              filter: 'invert(90%) hue-rotate(180deg) brightness(0.95) contrast(0.9)'
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación Coach Pro Gimnasio San Miguel" data-id="element-65"></iframe>
            </div>

            <p className="text-lg text-gray-300 mb-6" data-id="element-66">
              No somos el gym más grande de Lima. No tenemos 500 máquinas ni
              spas de lujo.
            </p>
            <p className="text-xl font-bold text-white" data-id="element-67">
              Lo que sí tenemos es algo mucho más valioso:
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-68">
            <ul className="space-y-6" data-id="element-69">
              {features.map((feature, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.1
            }} className="flex items-start gap-4 bg-gym-dark p-4 rounded-lg border border-gym-charcoalLight hover:border-gym-green/30 transition-colors" data-id="element-70">
                  <CheckCircle2 size={24} className="text-gym-green shrink-0 mt-0.5" data-id="element-71" />
                  <span className="text-lg text-gray-200 font-medium" data-id="element-72">
                    {feature}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}